import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone, faArrowTurnDownRight, faCircleInfo, faCamera,faPenToSquare, faLock, faUnlock, faEllipsis, faPen, faRectangleVerticalHistory, faTrash } from '@fortawesome/pro-regular-svg-icons';

import { GlobalButtonFinal } from '../../global/GlobalStyles';
import ReactTooltip from 'react-tooltip';

import ShareDialog from '../../global/menu/ShareDialog';

import { faShare } from '@fortawesome/free-solid-svg-icons';

import { getCookie } from 'cookies-next';
import * as Sentry from '@sentry/nextjs';
import { borderRadius15, borderRadius22, borderRadius9 } from '../../global/Variables.js';
import messages from '../../../../src/messages';
import { FormattedMessage } from 'react-intl';
import { LangContext } from '../../../../src/ConnectedIntlProvider';


const StyledProduct = styled.div`
    min-width: 290px;
    overflow: visible;
    text-align: center;
    float: left;
    padding-bottom: 0px;
    background: white;
    margin-left: 15px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: none;

    &.withRendersCompleted{
        border:gray;
    }
        
    .infoIcon{
         opacity:0.5;
        position:absolute;
        right:10px;
        top:10px;
        z-index:3;
    }
    .renderIcon {
        opacity:0.5;
        position:absolute;
        right:40px;
        top:10px;
        z-index:3;
    }
    &.appExternal{
    }
button{
    position:relative;
}
    
    .productThumbnail {
        //overflow: hidden;
        padding-top: 15px;
        padding-bottom: 15px;
        height: 250px !important;
        position: absolute !important;
        width: 100%;
        left: 0;
        img {
            width: auto;
            max-width: unset;
            max-height: 100% !important;
            float: none;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            margin-left: 5px;
            transform-origin: 25% center;
         
            transition:all 0.3s ease;
            z-index: 5;
            &:hover{
                cursor:pointer;
                transform: translateX(-50%) scale(1.2);
            }
        }
        
      
    }
    &.withoutBG {
        .backgroundBox {
            display: none;
        }
        .gridProduct > div:nth-child(1) {
            width: 100%;
            height: 225px;
            left: 0;
            position: absolute;
            top: 46px;
            border-radius: ${borderRadius15};
        }
        .productInsideShrink {
            width: 170px;
        }
    }
    &.onlyBackground {
        .productInsideShrink {
            width: 170px;
        }
        color: white !important;
        span {
            color: white !important;
        }
        p {
            color: white !important;
        }
    }
    .lockIcon {
        position: absolute;
        right: 30px;
        
        top: 30px;
    }
    &.showProduct {
        display: inline-table;
    }
    &.gridProduct {
        width: 398px;
        max-height: 300px;

        border-radius: ${borderRadius9};
  
        
    }

        justify-items: center;

        -webkit-transform: unset;
        -ms-transform: unset;
        transform: unset;
        min-width: unset;
        padding-left: 13px;

        float: none;
        //border: 1px solid lightgray;

        margin-left: 50px;
        left: 0;
        margin-top: 50px;

        @media only screen and (max-width: 1399px) {
            width: 345px !important;
            margin-left: 40px  !important;
            margin-top: 40px  !important;
        }
        @media only screen and (max-width: 1199px) {
            width: 285px  !important;
        }
        @media only screen and (min-width: 992px) {
            &:nth-child(3n + 1) {
                margin-left: 0px  !important;
            }
        }

        @media only screen and (max-width: 991px) {
            width: 328px  !important;
            margin-left: 40px  !important;
            &:nth-child(2n + 1) {
                margin-left: 0px  !important;
            }
        }
        @media only screen and (max-width: 767px) {
            width: 100% !important;
            margin-left: 0px !important
        }

        transition: all 0.3s ease;

        .productHeader {
            height: 290px;

            &.productInsideShrink {
                height: 150px;
                position: relative !important;
            }
        }

        &.productDetail {
          
            .productHeader {
                height: 250px;
            }
            .productDescription {
                height: 60px;
                margin-top:15px;
                
                svg{
                    height:5px;
                }
            }
            .productInsideShrink {
                height: 173px;
                z-index: 99;
            }
        }
        .backgroundBox {
            position: absolute;
            top: 0;
            background: #fff;
            width: 100%;
            height: 100%;
            left: 0;
            z-index: -9;
            border-radius: ${borderRadius15};
        }
    }

    .productPopup {
        display: none;
        z-index: 7;
     
        height: 242px;
        background: white;
        border-radius: ${borderRadius22};
        box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.15);
   
        position: absolute;
        padding: 4px;
        left: 0;
        width:100%;

        margin-top: 15px;
        
        &.view{
            height: 198px;
        }
        &.withRenders {
            height: 279px;
        }

            @media(max-width:450px){
                height: 269px;
            }
        &.inDetail {
            height: 206px;
            &.appExternal {
            height:60px;
                ul {
                    border:none;
                }
            }
            &.withRenders {
                height: 243px;
            }
        }
        &.active {
            display: block;
        }
     
        hr {
            margin: 0;
            margin-top: 4px;
            margin-bottom: 4px;
            color: #d9d9d9;
            opacity: 1;
        }
        ul {
            list-style-type: none;
            text-align: left;
            padding: 0;
            margin: 0;

            li {
                transition: all 0.3s ease;
                font-size: 18px;
                padding: 5px;
                border-radius: ${borderRadius22};
                padding-left: 15px;
                line-height: 26px;

                span {
                    transition: all 0.3s ease;
                    margin-left: 10px;
                    color: #666;
                    font-size: 18px !important;
                    font-weight: 400;
                }
                svg {
                    transition: all 0.3s ease;
                    color: #666;
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.15);
                    cursor: pointer;
                    span,
                    svg {
                        color: rgba(0, 0, 0, 1);
                    }
                }
                &.active {
                    color: #3d55d7;
                    span,
                    svg {
                        color: #3d55d7;
                    }
                }
            }
        }
        
        @media(max-width:600px){
            left: 50%;
            transform: translateX(-50%);
        }
        .deleteAlert{

            &:hover{
                color:white;
                span,svg{
                    color:white;
                }
                background-color: #C80000;
            }
        }
    }
    

    img {
        max-width: 40%;
    }
    p,
    h3,
    span {
        padding: 0;
        margin: 0;
    }

    .productHeader {
        position: relative;
        max-height: 320px;
        height: 320px;
        transition: all 0.3s ease;
        img {
            max-height: 100%;
            transition: all 0.3s ease;
        }
        &:hover {
            img {
                transform: scale(1.05) translateX(-50%);
            }
        }
    }
    .productButtons {
        padding-bottom: 35px;
        padding-right: 15px;
        button {
            padding: 3px;
        }
    }
    .productDescription {
        height: 125px;
        position: relative;
        padding-top: 15px;
        padding-bottom: 0;
        padding-right: 15px;
        text-align: center;
        padding-left: 15px;
        border-radius: ${borderRadius15};
        border-start-start-radius: 0px;
        border-start-end-radius: 0;

        svg{
            color: #666;

            height: 12px;
            margin-left: 5px;
            margin-right: 6px;
            margin-top: -1px;
            
            path{
                fill:#666;
            }
            
        }
        &.productInsideShrink {
            height: 173px;
            z-index: 99;
        }
        &.withThumbnail {
            height: auto !important;
            padding-bottom: 15px;
            padding-top: 0;
        }

        .date {
            font-size: 14px;
            font-weight: 400;
        }
        h4 {
            max-width: 100%;
            margin-top: 5px;
            font-size: 16px !important;
            margin-bottom: 10px !important;
            font-weight: 400 !important;
            color:black;
        }
        //h3,
        //h3:hover,
        //h3:active,
        //h3:focus{
        //
        //  text-decoration:none;
        //  font-weight: 600;
        //  padding-bottom: 5px;
        //  color: #2C2C2E;
        //  margin:0;
        //}
     
        span,p {
            color: #666;
            text-decoration: none;
            font-size: 14px;
            font-weight: 300;
        }

        .productPopupButton {
            position: absolute;
            top: 18px;
            right: 25px;
            width: 17px;
            height: 30px;
            display: block;

            &.productDetail {
                top: -44px;
            }
            button {
                color: #8e8e93;
                //position: absolute;
                text-align: center;
                //right: 15px;
                //bottom: -4px;
                width: 100%;
                background: transparent;
                border: none;
                font-size: 21px;
                height: 30px;
                transition: all 0.3s ease;
                padding: 0;
                opacity: 0.5;
                &:hover,
                &.active {
                    opacity: 1;
                    //  background:lightgray;
                    //  color:white;
                }
                svg {
                    //top: -1px;
                    position: relative;
                    path {
                        color: #424242;
                    }
                    width: 100%;
                    max-height: 18px;
                }
            }
        }
    }
    .productIconState {
        position: absolute;
        right: 15px;
        top: 15px;

        max-width: unset !important;
    }
    a,
    a:hover,
    a:active,
    a:focus,
    a:visited {
        color: black;
        text-decoration: none;
    }

    &.spiky {
        border-radius: 0;
    }

    &.productInsideShrink {
        width: 175px;
        margin-left: 15px !important;
        margin-top: 15px;

        border: 1px solid white;
        transition: all 0.3s ease;
        background: white;
        .whiteImage {
            opacity: 1;
            position: absolute;
            //top: 15px;
            //left: 17px;
        }
        &:hover,
        &.activeSelect {
            cusror: pointer;
            //  border: 1px solid gray;
         //   background: #f2f2f2;

            .whiteImage {
                opacity: 0;
            }

            .backgroundBox {
                transition:all 0.3s ease;
                background:#f2f2f2;
                display:block;
                opacity:0.8;
                cursor:pointer;
                z-index:98;
            }
        }
        .backgroundBox {
            transition:all 0.3s ease;
            background:#f2f2f2;
            display:block;
            opacity:0;
            z-index:98;
        }
    }
    &.withThumbnail {
        width: 100%;
       
        }
        
        img{
            margin-left:0 !important;
        }
        .productDescription{
           margin-top:30px;
        }
    }
`;

const StyledThreeTumbnail = styled.div`
    width: 100%;
    height: 260px;
    display: block;

    > div:nth-child(1) {
        width: 93%;
        height: 281px;
        left: 0;
        position: absolute;
        top: 0;
        border-radius: ${borderRadius15};
        @media (max-width: 8000px) {
            top: 0;
        }
    }
    &.gridProduct {
        > div:nth-child(1) {
            width: 100%;
            height: 320px;
            left: 0;
            position: absolute;
            top: 0;
            border-radius: ${borderRadius15};
        }
    }

    &.productDetail {
        > div:nth-child(1) {
            position: absolute;
          
            left: 0;
            position: absolute;
            top: 0;
            border-radius: ${borderRadius15};
            width: 100%;
            height: 300px;
        }
    }

    canvas {
        border-radius: ${borderRadius15};
    }
`;

export default function Product({
    props: any,
    createdAt,
    createdBy,
               appExternal,
                                    can_be_rendered,
                                    userPermissions,
    clickEvent,
    triggerWarning,
                                    userDeveloper,
                                    completed_renders,
    productThumbnail,
    productInsideShrinkVersion,
    onlyBackground,
    openDuplicateDialogAndSetIDZ,
    onClickChooseShrinkFunction,
    productVersionsList,
    openDeleteDialogAndSetIDZ,
     openLockVersionDialogAndSetIDZ,
    loadProductDetailWithVersions,
    productShrinkSelected,
    withThumbnail,
    lastUpdatedTime,
    productFullName,
    openMoveDialogAndSetIDZ,
    openRenameDialogAndSetIDZ,
    productInsideShrink,
    classes,
    productLocked,
    productType,
    productPackageGroup,
    productPackageLastUUID,
    productVolume,
    productDetail,
    styleInner,
    threeID,
    productName,
    productBrand,
    productVersions,
    productEdition,
    masterProductID,
    productID,
    productSelected,
    selectingMultiple,
    productClient,
}) {


    const [sharePersonPopupOpened, setSharePersonPopupOpened] = useState(false);

    const changeOpenedPopup = () => {

        if(!sharePersonPopupOpened){
            setSharePersonPopupOpened(true);
        }else {
            setSharePersonPopupOpened(false);
        }

    };

    const ref = useRef(null);

    useEffect(() => {
        const handleOutSideClick = event => {
            if (!ref.current?.contains(event.target)) {
                //     alert("Outside Clicked.");
            /*    if( data-ignoreclose={true})*/

                if( event.target.getAttribute("data-ignoreclose") !== "true"){
                    setSharePersonPopupOpened(false);
                }


            }
        };

        window.addEventListener('mousedown', handleOutSideClick);

        return () => {
            window.removeEventListener('mousedown', handleOutSideClick);
        };
    }, [ref]);

    const [loadShareDialog, setLoadShareDialog] = useState(false);

    const [showShareDialog, setShowShareDialog] = useState(false);
    const [showShareDialogTransition, setShowShareDialogTransition] = useState(false);

    const changeShareShow = variable => {
        if (variable === true) {
            setShowShareDialog(true);

            setTimeout(function () {
                setShowShareDialogTransition(variable);
            }, 2);

            setLoadShareDialog(true);
        } else {
            setShowShareDialogTransition(false);
            setTimeout(function () {
                setShowShareDialog(variable);
            }, 500);
        }
    };



    const [allowLock, setAllowLock] = useState(true);

    const lockVersion = () => {
        var allProductsArray = [];
        setAllowLock(false);
        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'products/' + masterProductID + '/versions/' + productID, {
            method: 'PUT',
            body: JSON.stringify({
                locked: productLocked ? false : true,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('products/' + masterProductID + '/versions/' + productID + ': ' + data.message + ' : ' + getCookie('userMail'));
                }
                setAllowLock(true);
                loadProductDetailWithVersions();
            });
    };

    function capitalize(s) {
        return s[0].toUpperCase() + s.slice(1);
    }

    useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    const { language, setLanguage } = useContext(LangContext)

    return (
        <>
            <StyledProduct
                style={productSelected ? { border: '1px solid #3D55D7' } : {}}
                className={` ${completed_renders && completed_renders > 0  ? 'withRendersCompleted' : ''} ${onlyBackground === 'true' ? 'onlyBackground' : ''}${onlyBackground === 'false' ? 'withoutBG' : ''} ${productShrinkSelected ? 'activeSelect' : ''} ${
                    productInsideShrink ? 'productInsideShrink' : ''
                } ${productType === 'GRID' ? 'gridProduct' : ''} ${classes} ${styleInner === 'spiky' ? 'spiky' : ''}  ${productDetail ? 'showProduct productDetail' : ''}`}
                onClick={!productInsideShrink ? e => clickEvent(e) : () => onClickChooseShrinkFunction(productID)}
                data-productid={productID} data-closemodalmenu={true}
            >
                {can_be_rendered  && userDeveloper ?
                <FontAwesomeIcon className="renderIcon" icon={faCamera}
                                 data-tip={language === "cs" ? "Podporuje render packshotu" : "Support render packshots"} data-place="bottom" data-delay-show="200"
                />: null}

                <FontAwesomeIcon className="infoIcon" icon={faCircleInfo}
                                 data-tip={language === "cs" ? 'Vytvořil ' + createdBy + " - " + new Date(createdAt).toLocaleString():'Created by ' + createdBy + " at " + new Date(createdAt).toLocaleString()} data-place="bottom" data-delay-show="200"
                />

                {selectingMultiple ? <div style={{ position: 'absolute', zIndex: '10', width: '100%', height: '100%', top: '0', left: '0' }} data-productid={productID}></div> : null}

                {productDetail ? (
                    <>
                        {' '}
                        {productLocked ? (
                            <FontAwesomeIcon onClick={allowLock ? () => openLockVersionDialogAndSetIDZ(productID, masterProductID, productLocked) : null} className="lockIcon" icon={faLock} />
                        ) : (
                            <FontAwesomeIcon onClick={allowLock ? () =>  openLockVersionDialogAndSetIDZ(productID, masterProductID, productLocked)  : null} className="lockIcon" icon={faUnlock} />
                        )}
                    </>
                ) : null}

                {productThumbnail ? (
                    <div className={`${productInsideShrink ? 'productInsideShrink' : ''} productHeader productThumbnail`}>

                        <img    onClick={() => window.open(productDetail ? '/editor/' + productID : '/editor/' + productPackageLastUUID,"_self")} src={productThumbnail} id={threeID} className={`  ${productType === 'GRID' ? 'gridProduct' : ''} ${productDetail ? 'productDetail' : ''}`} />

                    </div>
                ) : (
                    <div className={`${productInsideShrink ? 'productInsideShrink' : ''} productHeader productThumbnail`}>
                        <img src={'/images/thumb_obalero.png'} id={threeID} className={`  ${productType === 'GRID' ? 'gridProduct' : ''} ${productDetail ? 'productDetail' : ''}`} />
                    </div>
                )}

                {!productInsideShrink ? (
                    <Link href={productDetail ? '/editor/' + productID : '/editor/' + productPackageLastUUID}>
                        <div className={`${productInsideShrink ? 'productInsideShrink' : ''} productHeader`}>
                            <StyledThreeTumbnail id={threeID} className={`${productType === 'GRID' ? 'gridProduct' : ''} ${productDetail ? 'productDetail' : ''}`}></StyledThreeTumbnail>
                        </div>
                    </Link>
                ) : (
                    <>
                        {!withThumbnail ? (
                            <div className={`${productInsideShrink ? 'productInsideShrink' : ''} productHeader`}>
                                <StyledThreeTumbnail id={threeID} className={`${productType === 'GRID' ? 'gridProduct' : ''} ${productDetail ? 'productDetail' : ''}`}></StyledThreeTumbnail>
                            </div>
                        ) : null}
                    </>
                )}

                <div data-closemodalmenu={true} className={`${productInsideShrink ? 'productInsideShrink' : ''} ${withThumbnail ? 'withThumbnail' : ''} productDescription`}>




                    {productDetail ?
                        <>
                            <FormattedMessage {...messages.products_descriptions_version}>
                                {(msg) => (
                                    <h4 className={'mb-3'}>{capitalize(msg)+' ' + productVersions}</h4>
                                )}
                            </FormattedMessage>

                        </>
                        : <h4 className={'mb-3'}>{productName}</h4>
                    }



                    {productClient &&
                    productBrand &&
                    productEdition &&
                    (productClient.toString().replaceAll(',', '') || productBrand.toString().replaceAll(',', '') || productEdition.toString().replaceAll(',', '')) &&
                    !productInsideShrinkVersion ? (
                        <>
                            <span>
                                {productClient.toString().replaceAll(',', '')}
                                {productBrand.toString().replaceAll(',', '') ? " / " + productBrand.toString().replaceAll(',', '') : ''}
                                {productEdition.toString().replaceAll(',', '') ? " / " + productEdition.toString().replaceAll(',', '') : ''}
                            </span>
                            {!productInsideShrink ? <br /> : null}
                        </>
                    ) : <p style={{ color: 'transparent' }}>&nbsp;-</p>}

                    {!productDetail && !productInsideShrinkVersion ? (
                        <span>
                            {' '}
                            {productPackageGroup}
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className={'fa-caret-right halfing'}
                                 viewBox="0 0 256 512">
                                                <path
                                                    d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" />
                                            </svg>
                            {productVolume}
                        </span>
                    ) : null}



                    {productDetail || productInsideShrinkVersion ?
                   null
                    : <>


                        {language === "cs" ?
                              <>
                                  {productVersions >= 5 ?
                                      <FormattedMessage {...messages.products_descriptions_version_plural}>
                                          {(msg) => (
                                              <p>{productVersions + " " + msg} </p>
                                          )}
                                      </FormattedMessage> :
                                      <FormattedMessage {...messages.products_descriptions_version}>
                                          {(msg) => (
                                              <p>{productVersions + " " + msg}</p>
                                          )}
                                      </FormattedMessage>
                                  }


                              </>  :
                            <>
                                {productVersions >= 2 ?
                                    <FormattedMessage {...messages.products_descriptions_version_plural}>
                                        {(msg) => (
                                            <p>{productVersions + " " + msg}</p>
                                        )}
                                    </FormattedMessage> :
                                    <FormattedMessage {...messages.products_descriptions_version}>
                                        {(msg) => (
                                            <p>{productVersions + " " + msg}</p>
                                        )}
                                    </FormattedMessage>
                                }

                            </>
                            }

                            {completed_renders == 0 ?
                                <p>&nbsp;</p>: null
                            }


                            {completed_renders == 1 ?
                                <FormattedMessage {...messages.products_descriptions_packshot}>
                                    {(msg) => (
                                        <p>{completed_renders + " " + msg} </p>
                                    )}
                                </FormattedMessage> : null
                            }

                            {completed_renders >= 2 && completed_renders < 5 ?
                                <FormattedMessage {...messages.products_descriptions_packshot_semi_plural}>
                                    {(msg) => (
                                        <p>{completed_renders + " " + msg} </p>
                                    )}
                                </FormattedMessage> : null
                            }
                            {completed_renders >= 5 ?
                                <FormattedMessage {...messages.products_descriptions_packshot_plural}>
                                    {(msg) => (
                                        <p>{completed_renders + " " + msg} </p>
                                    )}
                                </FormattedMessage> : null
                            }


                        </>

                    }



                    {lastUpdatedTime ? (
                        <div className={`lastUpdated`}>
                            <span>{lastUpdatedTime}</span>
                        </div>
                    ) : null}
                </div>

                {!productInsideShrink ? (
                    <div className={'productButtons'}>
                        <Link href={productDetail ? '/editor/' + productID : '/editor/' + productPackageLastUUID}>


                            <GlobalButtonFinal className={'borderBlueProduct btn-circle'}
                                               style={{ width: '84%', marginTop: '5px' }}>
                                <FontAwesomeIcon icon={faPen} style={{ marginRight: '13px' }} />

                               {/* {!appExternal ?
                                    <FormattedMessage {...messages.products_buttons_edit}></FormattedMessage>
                                    : <FormattedMessage {...messages.products_buttons_view}></FormattedMessage>
                                }
                                */}
                                <FormattedMessage {...messages.products_buttons_edit}></FormattedMessage>


                            </GlobalButtonFinal>
                        </Link>
                        { userPermissions === "edit" ?
                            <GlobalButtonFinal data-closemodalmenu={true}
                                               data-ignoreclose={true}
                                               onClick={() => changeOpenedPopup()}
                                               className={'borderBlueProduct btn-circle'}
                                               style={{ width: '84%', marginTop: '18px' }}
                            >
                                <FontAwesomeIcon icon={faEllipsis} style={{ marginRight: '12px' }} />



                                    <FormattedMessage {...messages.products_buttons_more}></FormattedMessage>



                                <div
                                    className={`${userPermissions} ${completed_renders && completed_renders > 0 ? 'withRenders' : ''} ${sharePersonPopupOpened ? 'active productPopup' : 'productPopup'} ${productDetail ? 'inDetail' : ''}  `}
                                    ref={ref}>
                                    <ul>


                                        {completed_renders && completed_renders > 0  ?
                                            <Link href={productDetail ? '/packshots-detail/' + masterProductID +"?version="+ productID : '/packshots-detail/' + productID}>
                                                <li>
                                                    <FontAwesomeIcon icon={faCamera} />
                                                    <span><FormattedMessage {...messages.products_buttons_show_packshots}></FormattedMessage></span>
                                                </li>
                                            </Link>: null}


                                            <>
                                                <li onClick={() => changeShareShow(true)}>
                                                    <FontAwesomeIcon icon={faShare} />
                                                    <span><FormattedMessage {...messages.products_buttons_share}></FormattedMessage></span>
                                                </li>
                                                <hr />
                                            </>


                                        {productDetail ? null : (
                                            <Link href={'/products/' + productID}>
                                                <li>
                                                    <FontAwesomeIcon icon={faRectangleVerticalHistory} />
                                                    <span><FormattedMessage {...messages.products_buttons_view_all_versions}></FormattedMessage></span>
                                                </li>
                                            </Link>
                                        )}

                                        {/*{!appExternal ?
                                            <>*/}
                                                <li onClick={() => openDuplicateDialogAndSetIDZ(productID, productVersionsList, productName, masterProductID)}>
                                                    <FontAwesomeIcon icon={faClone} />
                                                    <span><FormattedMessage {...messages.products_buttons_duplicate}></FormattedMessage></span>
                                                </li>
                                                <li onClick={(e) => openMoveDialogAndSetIDZ(productID, e)}>
                                                    <FontAwesomeIcon icon={faArrowTurnDownRight} />
                                                    <span><FormattedMessage {...messages.products_buttons_move}></FormattedMessage></span>
                                                </li>
                                                <li onClick={() => openRenameDialogAndSetIDZ(productID, productFullName)}>
                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                    <span><FormattedMessage {...messages.products_buttons_rename}></FormattedMessage></span>
                                                </li>
                                                <hr />
                                                <li className={"deleteAlert"}
                                                    onClick={() => openDeleteDialogAndSetIDZ(masterProductID, productID)}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                    <span><FormattedMessage {...messages.products_buttons_delete}></FormattedMessage></span>
                                                </li>
                                    {/*        </>
                                            : null}*/}

                                    </ul>
                                </div>


                            </GlobalButtonFinal>
                        :
                            <>
                                {!productDetail || (productDetail && userPermissions === "edit") ?
                                    <Link href={'/products/' + productID}>
                                        <GlobalButtonFinal data-closemodalmenu={true}
                                                           data-ignoreclose={true}
                                                           className={'borderBlueProduct btn-circle'}
                                                           style={{ width: '84%', marginTop: '18px' }}
                                        >
                                            <FormattedMessage {...messages.products_buttons_view_all_versions}></FormattedMessage>
                                        </GlobalButtonFinal>
                                    </Link>
                                : null
                                }
                            </>
                            }

                    </div>
                ) : null}

                {loadShareDialog ? (
                    <ShareDialog
                        triggerWarning={triggerWarning}
                        // disableLoad={true}
                        isProductDetail={productDetail ? true : false}
                        slugState={productDetail ? productID : productPackageLastUUID}
                        typeEditor={false}
                        showShareDialog={showShareDialog}
                        showShareDialogTransition={showShareDialogTransition}
                        changeShareShow={changeShareShow}
                    />
                ) : null}

                <ReactTooltip />
                <div className={'backgroundBox'}></div>
            </StyledProduct>
        </>
    );
}
